var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('ul',{staticClass:"wjclass"},_vm._l((_vm.list),function(item){return _c('li',{key:item.questionnaireid,on:{"click":function($event){return _vm.push(item)}}},[_vm._v(_vm._s(item.questionnairename))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2643eda","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Index/questionnaire/questionnaire.vue
// module id = null
// module chunks = 